<template>
  <div id="reset-wrapper"><a @click="showConfirm = true"><img src="../assets/images/icons/home.png" class="full-logo"></a></div>
</template>

<script>
export default {
  name: 'Brand'
}
</script>

<style scoped>
img {
  z-index: 1000;
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Brand.vue